export enum TmModalCloseReason {
  SUBMIT,
  CLOSE
}
